import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Homepage / service-page call-out for the free Website Audit tool.
 * The URL field deep-links into /website-audit?url=… which auto-runs the scan.
 */
const AuditPromo = () => {
    const [url, setUrl] = useState('');
    const navigate = useNavigate();
    const go = (e) => {
        e.preventDefault();
        const q = url.trim();
        navigate(q ? `/website-audit?url=${encodeURIComponent(q)}` : '/website-audit');
        window.scrollTo(10, 0);
    };
    return (
        <section className="section_space" style={{ background: 'var(--bs-dark)' }}>
            <div className="container">
                <div className="row align-items-center" style={{ rowGap: 22 }}>
                    <div className="col-lg-6">
                        <div style={{ color: 'var(--bs-primary)', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', fontSize: '.82rem', marginBottom: 6 }}>
                            Free Tool · Instant Results
                        </div>
                        <h2 style={{ color: '#fff', marginBottom: 12 }}>How healthy is your website?</h2>
                        <p style={{ color: 'rgba(255,255,255,0.82)', marginBottom: 0, maxWidth: 520 }}>
                            Get a free, instant audit of your site’s <strong style={{ color: '#fff' }}>SEO, speed, accessibility, and best practices</strong> —
                            scored, with a prioritized fix list. No signup to see your scores.
                        </p>
                    </div>
                    <div className="col-lg-6">
                        <form onSubmit={go}>
                            <label htmlFor="home-audit-url" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '.85rem', display: 'block', marginBottom: 8 }}>Enter your website</label>
                            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                <input
                                    id="home-audit-url"
                                    type="text"
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                    placeholder="yoursite.com"
                                    aria-label="Your website URL"
                                    style={{ flex: '1 1 240px', minWidth: 0, border: 'none', borderRadius: 10, padding: '14px 16px', fontSize: '1rem' }}
                                />
                                <button type="submit" className="btn btn-primary" style={{ whiteSpace: 'nowrap' }}>
                                    <span className="btn_label" data-text="Run my free audit">Run my free audit</span>
                                    <span className="btn_icon"><i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i></span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AuditPromo;
